export default __webpack_public_path__ + "5d3c79f5cc14fabae98c66e2d6d192fd.png";